module.exports = __webpack_public_path__ + "img/cat1.aa75d617.png";